import React from "react";
import DDIIcon from "./ddi_icon";
import { Button } from "react-bootstrap";
import { usePatientContext } from "data/patientContext";
import { useNavigate } from "react-router-dom";
import { getDrugGroup } from "data/ddis";
import ga4 from "react-ga4";
import { useTranslation } from "react-i18next";

const DdiItem = ({ data, patientControls, groupCategory = null }) => {
	const { t } = useTranslation();
	const patient = usePatientContext();
	const navigate = useNavigate();

	const drugName = data.nameKey ? t("ddis_common:" + data.nameKey) : data.name;
	const groupKey = data.categoryKey || getDrugGroup(data.name);

	const addToPatient = () => {
		patient.add(data);
		if (groupCategory) {
			ga4.event({
				category: "app-interaction",
				action: "add-drug-group",
				label: groupCategory,
				drug_name: drugName,
				group_category: groupCategory,
			});
			ga4.event({
				category: "app-interaction",
				action: "add-drug",
				label: drugName,
				drug_name: drugName,
				group_category: groupCategory,
			});
		}
	};
	const removeFromPatient = () => {
		patient.remove(data);
	};
	const switchDrug = () => {
		const groupName = groupKey;
		console.log("Viewing alternatives ", groupName);
		ga4.event({
			category: "app-interaction",
			action: "patient-switch-drug-category",
			label: groupName,
			group_category: groupName,
		});
		ga4.event({
			category: "app-interaction",
			action: "patient-switch-drug",
			label: drugName,
			drug_name: drugName,
		});

		navigate("/private/groups", { state: { category: groupName } });
	};

	return (
		<tr className="ddi-row onhover-container">
			<td>
				{patientControls?.indexOf("add") >= 0 && (
					<Button
						onClick={addToPatient}
						className="btn-icon me-2 onhover"
						size="sm"
						title={t("auto.adicionarAoPerfilDeDoente")}
					>
						<i className="bi bi-person-fill-add" />
					</Button>
				)}
				{patientControls?.indexOf("remove") >= 0 && (
					<Button
						onClick={removeFromPatient}
						className="btn-icon me-2 onhover"
						size="sm"
						title={t("auto.removerDoPerfilDeDoente")}
					>
						<i className="bi bi-x" />
					</Button>
				)}
				{patientControls?.indexOf("group") >= 0 && (
					<Button
						onClick={switchDrug}
						className="btn-icon me-2 onhover"
						size="sm"
						title={t("auto.encontrarAlternativaDoMesmoGrupoFarmacologico")}
					>
						<i className="bi bi-arrow-left-right" />
					</Button>
				)}
				{drugName}
			</td>
			<td>
				<DDIIcon value={data.interactions.abemaciclib} />
			</td>
			<td>
				<DDIIcon value={data.interactions.palbociclib} />
			</td>
			<td>
				<DDIIcon value={data.interactions.ribociclib} />
			</td>
		</tr>
	);
};

export default DdiItem;
